module.exports = __webpack_public_path__ + "img/logo-rossignol.c6acd6fd.svg";